import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-payment-discount-dialog',
  templateUrl: './buzzer-dialog.component.html',
  styleUrls: ['./buzzer-dialog.component.scss'],
})
export class BuzzerDialogComponent {

  buzzerPresets = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25'];
  selectedBuzzer;
  selectedBuzzerIndex;
  chunkedBuzzerPresets: string[][] = [];

  constructor(
    private dialogRef: MatDialogRef<BuzzerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.chunkArray(this.buzzerPresets, 5);
  }

  chunkArray(array: string[], size: number): void {
    for (let i = 0; i < array.length; i += size) {
      this.chunkedBuzzerPresets.push(array.slice(i, i + size));
    }
  }

  submit() {
    this.dialogRef.close({
      selectedBuzzer: this.selectedBuzzer,
    });
  }

  selectBuzzer(item: string, itemIndex: number) {
    this.selectedBuzzerIndex = itemIndex;
    this.selectedBuzzer = item;
  }
}
